// @flow

export const ADD = 'ADD'
export const EDIT = 'EDIT'
export const DELETE = 'DELETE'
export const READ = 'READ'
export const OTHER = 'OTHER'

export const UPDATE_OPERATION = 'UPDATE_OPERATION'
export const UPDATE_OPERATIONS = 'UPDATE_OPERATIONS'
export const SUBMIT_OPERATION = 'SUBMIT_OPERATION'
export const SUBMIT_OPERATIONS = 'SUBMIT_OPERATIONS'
export const CANCEL_OPERATION = 'CANCEL_OPERATION'
export const CANCEL_OPERATIONS = 'CANCEL_OPERATIONS'
